import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CampaignServiceService } from './campaign-service.service';
import { ActivatedRoute } from '@angular/router';
import { UtilityService } from './utility/utility.service';
import { CampaignService } from './campaign/campaign.service';

@Injectable({
  providedIn: 'root'
})
export class CollegeDataService {

  private messageSource = new BehaviorSubject([]);
  private obtainedExcelData = new BehaviorSubject([]);
  currentExcelData = this.obtainedExcelData.asObservable();

  currentMessage = this.messageSource.asObservable();
  collegeDetails: any[];
  cards: any[];
  data: any[];
  type: String = "";
  id: String = "";

  constructor(private campaign: CampaignServiceService,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private campaignService: CampaignService

    ) {

  }

  ngOnInit() {
    this.type = this.route.snapshot.paramMap.get('type');
    this.id = this.route.snapshot.paramMap.get('id');
       this.getData();
   
    }

  changeMessage(data: any) {

    this.messageSource.next(data);

  }

  getData() {
    this.utility.showSpinner();
    this.campaignService.getDetailsByTypeAndId(this.type, this.id)
      .subscribe(response => {
        console.log("TypeandId", response);
        // this.data = (response as any).data;
        console.log("my data", this.data)
        // this.carddata = this.data;
        this.obtainedExcelData.next((response as any).data);

        // console.log("my data1", this.carddata)
        this.utility.hideSpinner();
      });
  }
}
